import { Currency } from "./currency";
import { SalesProductType } from "./sales-product-type";
import Decimal from 'decimal.js';

export class ContactRequestQuotationProduct {

    constructor(
        public productType: SalesProductType,
        public description: string,
        public amount: Decimal,
        public currency: Currency,
        public id?: number
    ){}
}
